<template lang="pug">
div
  Label(icon="mdi-map-marker", title="Address")
  #address-box.d-flex.flex-row.align-center.justify-space-between
    v-menu
      template(v-slot:activator="{ on }")
        .d-flex.flex-row.align-center.mr-5.my-1(v-on="on", role="button")
          .font-weight-medium(v-if="cartOrder.customer.address")
            div {{ cartOrder.customer.address | address("street") }}
            div {{ cartOrder.customer.address | address("city, state") }}
          span(v-else) Select
          v-icon(right) mdi-menu-down
      v-card
        v-list.py-0(
          v-if="$auth.user().addresses && $auth.user().addresses.length",
          two-line
        )
          v-list-item(
            v-for="(item, index) in $auth.user().addresses",
            :key="index",
            @click="setAddress(item)"
          )
            v-list-item-content
              v-list-item-title {{ item | address("street") }}
              v-list-item-subtitle {{ item | address("city, state") }}
            v-list-item-action
              v-btn(icon, color="error", @click="handleRemove(item._id)")
                v-icon(small) mdi-delete
    v-icon(@click="add()") mdi-plus
  div(v-if="cartOrder.customer.address")
    .body-2.mb-2 Delivery Instruction
    v-text-field(
      v-model="cartOrder.customer.address.note",
      dense,
      placeholder="Delivery Instruction",
      hide-details
    )
  Status
  UserAddressForm(@saved="setAddress")
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/event-bus.js";
import Status from "./Status";

export default {
  name: "CartAddress",
  components: { Status },
  computed: { ...mapGetters(["cartOrder"]) },
  methods: {
    ...mapActions(["setAddress"]),
    handleRemove(id) {
      confirm("Do you want to remove this address?") && this.remove(id);
    },
    add() {
      EventBus.$emit("user.address:edit");
    },
    async remove(id) {
      const user = this.$auth.user();
      if (!user) return;
      const params = {
        criteria: { _id: user._id },
        action: { $pull: { addresses: { _id: id } } },
      };
      this.loading = true;
      const res = await this.axios.post("/users/update", params);
      this.loading = false;
      this.$auth.user(res.data);
      this.setAddress();
    },
  },
};
</script>

<style lang="sass" scoped>
#address-box
  overflow-x: scroll
</style>
